// @flow
import * as React from 'react';
// $$FlowFixMe
import { useState, useEffect } from 'react';
import { useAuth } from 'ducks/auth-context';
import { setFeaturedMedia } from 'containers/client/UgcFeaturedMediaApi';
import classnames from 'classnames';

type FeaturedMediaProps = {
  ugc_id: UgcId,
  ugc_type: string,
  featured: boolean,
  onSubmit: Function,
};

const delay = timeout => new Promise(resolve => setTimeout(resolve, timeout));

export function UgcFeaturedMedia(props: FeaturedMediaProps) {
  const { ugc_id, ugc_type, featured, onSubmit } = props;
  const { token } = useAuth();
  const [requestStatus, setRequestStatus] = useState(null);

  const loading = requestStatus === 'pending';
  const errored = requestStatus instanceof Error;
  const completed = requestStatus === 'complete';

  useEffect(() => {
    // clear error message after 3 seconds
    let timeoutId;
    let current = true;

    if (completed || errored) {
      timeoutId = setTimeout(() => {
        if (current) {
          setRequestStatus(null);
        }
      }, 3000);
    }

    return () => {
      current = false;
      timeoutId && clearTimeout(timeoutId);
    };
  }, [requestStatus]);

  async function handleChange(e: SyntheticEvent<HTMLInputElement>) {
    const featured = e.currentTarget.checked;
    try {
      setRequestStatus('pending');
      await delay(1000);
      const response = await setFeaturedMedia(token, {
        ugcId: ugc_id,
        featured,
      });
      onSubmit({ featured: response.featured });
      setRequestStatus('complete');
    } catch (e) {
      setRequestStatus(e);
    }
  }

  const descriptionLabelId = `${ugc_id}-description-featured-media`;
  const errorDescriptionLabelId = `${ugc_id}-description-featured-media`;

  return (
    <div
      className={classnames('flex items-start pt3', {
        'o-70': loading,
      })}
      style={{ minHeight: 67 }}
    >
      <input
        id={`${ugc_id}-featured-checkbox`}
        type="checkbox"
        checked={loading ? !featured : featured}
        onChange={handleChange}
        disabled={requestStatus != null}
        className="mt1"
        aria-describedby={
          errored ? errorDescriptionLabelId : descriptionLabelId
        }
      />
      <div className="flex flex-column pl2">
        <label
          htmlFor={`${ugc_id}-featured-checkbox`}
          className="brandon b f4 dark-gray"
        >
          {`Featured ${ugc_type}`}
        </label>
        {errored ? (
          <p
            id={errorDescriptionLabelId}
            className="brandon tl f6 normal db dark-red mv0"
          >
            An error occured while saving your preference, please try again.
          </p>
        ) : (
          <p
            id={descriptionLabelId}
            className="brandon tl f6 normal db gray mv0"
          >
            {loading
              ? 'Saving...'
              : completed
              ? `${ugc_type} updated!`
              : `${ugc_type}s marked as featured will be given priority in your galleries and shown first.`}
          </p>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/client/UgcFeaturedMedia.js